import { FC, ReactNode, useEffect, useState } from 'react';
import IALogo from '../../../../../assets/img/IA.svg';

interface LoadingScreenProps {
    title: ReactNode;
    messages: string[];
    intervalMs?: number;
}

// Mesmo visual de loading usado em toda a simulação (título + mensagem rotativa + logo
// da IA), reaproveitado nas esperas de digitação/validação/efetivação da proposta.
const LoadingScreen: FC<LoadingScreenProps> = ({ title, messages, intervalMs = 1500 }) => {
    const [statusIdx, setStatusIdx] = useState(0);

    useEffect(() => {
        const iv = setInterval(() => {
            setStatusIdx((prev) => (prev + 1) % messages.length);
        }, intervalMs);
        return () => clearInterval(iv);
    }, [messages, intervalMs]);

    return (
        <div className="step-loading">
            <div className="step-loading__logo">
                <img src={IALogo} alt="IA" />
            </div>
            <p className="step-loading__title">{title}</p>
            <p className="step-loading__status" key={statusIdx}>{messages[statusIdx]}</p>
            <div className="step-loading__dots">
                <span /><span /><span />
            </div>
        </div>
    );
};

export default LoadingScreen;
